export function richTextCorrect (text) {
  if (text != null) {
    var a = text.split('</span>')
    var b
    var c
    var d
    var e = ''
    for (var i = 0; i < a.length - 1; i++) {
      if (a[i].indexOf('<span style="color: rgb(') !== -1) {
        b = a[i].split('<span style="color: rgb(')
        c = b[1].split(');">')
        d = getSixteenColor(c[0])
        a[i] = b[0] + '<font color="' + d + '">' + c[1] + '</font>'
      }
      e += a[i]
    }
    e += a[a.length - 1]
    return e
  } else {
    return text
  }
}

export function SixteenToRGB (str) {
  if (str != null) {
    var a = str.split('</font>')
    var b
    var c
    var d
    var e = ''
    for (var i = 0; i < a.length - 1; i++) {
      if (a[i].indexOf('<font color="') !== -1) {
        b = a[i].split('<font color="')
        c = b[1].split('">')
        d = colorRgb(c[0])
        a[i] = b[0] + '<span style="color: ' + d + '">' + c[1] + '</span>'
        e += a[i]
      }
    }
    e += a[a.length - 1]
    return e
  } else {
    return str
  }
}

function colorRgb (that) {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  var sColor = that.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    var sColorChange = []
    for (var j = 1; j < 7; j += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(j, j + 2)))
    }
    return 'rgb(' + sColorChange.join(',') + ');'
  } else {
    return sColor
  }
}

function getSixteenColor (str) {
  return '#' + str.split(',').map(function (component) {
    return ('00' + parseInt(component).toString(16)).slice(-2)
  }).join('')
}
